var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.642,
    height: 20.326,
    viewBox: "0 0 17.642 20.326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    transform: "translate(34.542 36.077) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M32.43,23.442H30.161l-.786,1.571a2,2,0,0,1-1.8,1.112H23.867a2,2,0,0,1-1.8-1.112l-.786-1.571H19.013A2.013,2.013,0,0,1,17,21.43v-.671a1.342,1.342,0,0,1,1.342-1.342h.067L19.569,7.811a2.007,2.007,0,0,1,2-1.811h8.305a2.007,2.007,0,0,1,2,1.811l1.161,11.606H33.1a1.342,1.342,0,0,1,1.342,1.342v.671A2.013,2.013,0,0,1,32.43,23.442Zm-9.162.971a.667.667,0,0,0,.6.371h3.708a.667.667,0,0,0,.6-.371l.486-.971H22.781ZM30.541,7.945a.671.671,0,0,0-.671-.6h-8.3a.671.671,0,0,0-.667.6L19.754,19.417H31.692ZM32.43,20.759H18.342v.671a.671.671,0,0,0,.671.671H32.43a.671.671,0,0,0,.671-.671v-.671Z",
    transform: "translate(0 9.851)",
    fill: "#f45e29",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M26.671,19a.671.671,0,0,1,.671.671v6.709a.671.671,0,1,1-1.342,0V19.671A.671.671,0,0,1,26.671,19Z",
    transform: "translate(-2.962 0.205)",
    fill: "#f45e29",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M32.671,19a.671.671,0,0,1,.671.671v6.709a.671.671,0,1,1-1.342,0V19.671A.671.671,0,0,1,32.671,19Z",
    transform: "translate(-4.937 0.205)",
    fill: "#f45e29",
    stroke: "#fff",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon_trash.21359b71.svg";
export { ForwardRef as ReactComponent };